export const MEDIA_FILTERS = [
  { value: "ALL", label: "All" },
  { value: "PHOTOS", label: "Photos" },
  { value: "VIDEOS", label: "Videos" },
];

export const MAX_PHOTO_BYTES = 15 * 1024 * 1024;
const PHOTO_TYPES = new Set(["image/jpeg", "image/png", "image/webp"]);

export const mediaSourceLabel = (sourceType) => ({
  ADMIN: "Bikeparks Finder",
  OPERATOR: "Operator",
  OFFICIAL_EXTERNAL: "Official",
  COMMUNITY: "Community",
}[sourceType] || "Unknown source");

export const mediaSourceTone = (sourceType) =>
  sourceType === "COMMUNITY" ? "community" : "official";

export const youtubeEmbedUrl = (media) =>
  media?.provider === "YOUTUBE" && media.external_id
    ? `https://www.youtube-nocookie.com/embed/${media.external_id}`
    : null;

export const validatePhotoFile = (file) => {
  if (!file) return "Choose a photo first.";
  if (!PHOTO_TYPES.has(file.type)) return "Photo must be JPEG, PNG or WebP.";
  if (!Number.isInteger(file.size) || file.size < 1 || file.size > MAX_PHOTO_BYTES) {
    return "Photo must be smaller than 15 MB.";
  }
  return null;
};

export const uploadCommunityPhoto = async ({ file, requestUpload, putFile, confirmUpload }) => {
  const validationError = validatePhotoFile(file);
  if (validationError) throw new Error(validationError);
  const authorization = await requestUpload();
  await putFile({ authorization, file });
  return confirmUpload(authorization.upload_id);
};
